import React from 'react';

const Blog = () => {
  return (
    <div id ="blog">
      <h1>This is the blog section</h1>
      <p>The blog will ablout assessment and learning generated with interaction with education and experiences</p>
      
    </div>
  )
}

export default Blog;
